export default "__VITE_ASSET__9fae54de__"